/** Support panel copy. Kept out of Help Center so Contentful FAQ sync cannot drop it. */
const dictionary = {
  en: {
    open: "Support Assistant",
    title: "Support Assistant",
    close: "Close",
    intro: "Ask how to use the page you are on.",
    placeholder: "Ask a question",
    send: "Send",
    thinking: "Looking that up",
    error: "Something went wrong. Email admin@apexteam.ai.",
    sources: "Source",
  },
  de: {
    open: "Support-Assistent",
    title: "Support-Assistent",
    close: "Schließen",
    intro: "Fragen Sie, wie die Seite funktioniert, auf der Sie gerade sind.",
    placeholder: "Frage stellen",
    send: "Senden",
    thinking: "Ich schaue nach",
    error: "Das hat nicht geklappt. Schreiben Sie an admin@apexteam.ai.",
    sources: "Quelle",
  },
  fi: {
    open: "Tukiavustaja",
    title: "Tukiavustaja",
    close: "Sulje",
    intro: "Kysy, miten käytät sivua, jolla olet.",
    placeholder: "Esitä kysymys",
    send: "Lähetä",
    thinking: "Etsin vastausta",
    error: "Jokin meni pieleen. Lähetä viesti osoitteeseen admin@apexteam.ai.",
    sources: "Lähde",
  },
};

export default dictionary;
